import { Controller } from '@hotwired/stimulus';
import consumer from '../../../channels';

export default class extends Controller {
  connect() {
    this.googleWorkspaceSyncSubscription = consumer.subscriptions.create(
      { channel: 'GoogleWorkspaceIntegrationSyncChannel' },
      {
        received: (_data) => {
          window.location.reload();
        },
      },
    )
  }

  disconnect() {
    if (typeof this.googleWorkspaceSyncSubscription !== 'undefined') {
      this.googleWorkspaceSyncSubscription.unsubscribe();
    }
  }
}
